import { WorldReady } from '@paypalcorp/worldready'

/**
 * Grabs the data we dump from the server into the DOM and exports them as a singleton.
 * This allows us to conveniently dump server data into the dom and use this to load
 * that data into our app.
 */
// because the way webpack is implemented, you can import this file anywhere
// in the codebase like so:
// import serverData from 'utils/server-data'

type Locality = {
  locale: string
}

interface MetaData {
  country: {
    [code: string]: {
      [key: string]: string
    }
  }
}

interface AppConfig {
  removeBankSelection : boolean
  addEmailField: boolean
}

interface ServerData {
  worldReady: string
  locality: Locality
  isMobile: boolean
  isSafari: boolean
  metaData: MetaData
  isStage: boolean
  isSandBox: boolean
  isProd: boolean
  merchantCurrency: string
  appConfig: AppConfig
}

const serverData = {} as ServerData

function init() {
  const dataNode = document.getElementById('server-data')

  if (!dataNode) {
    console.error('There was now element with the id of server-data.')
    return
  }

  try {
    const serverDataString = dataNode.innerHTML
    Object.assign(serverData, JSON.parse(serverDataString))

    if (dataNode.parentElement) {
      dataNode.parentElement.removeChild(dataNode) // cleanup the DOM
    }

    console.info('server-data loaded', serverData)

    if (process.env.NODE_ENV !== 'test') {
      // paypal-scripts will load worldReady with content automatically during tests
      WorldReady.load(serverData.worldReady)
    }
  } catch (err) {
    console.error('server-data: load', err)
  }
}

export default serverData
export { init }
/* eslint no-console:0 */
